import {FiChevronDown, FiChevronUp} from "react-icons/fi";
import CustomSpan from "./CustomSpan";
import React, {useState} from "react";

const ExpandablePanel = (props) => {
  const {title, children} = props;
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="border border-tenken-gray-400 w-full">
      <div className="flex justify-between bg-[#E0E0E0] xl:p-[12px] p-[10px] w-full">
        <CustomSpan
          className="font-bold text-[18px]"
          text={title}/>
        <button onClick={() => setExpanded(!expanded)}>
          {expanded ? <FiChevronUp size={20}/> : <FiChevronDown size={20}/>}
        </button>
      </div>
      <div
        className={`flex flex-col items-start xl:p-[30px_20px] p-[24px_16px] xl:gap-5 gap-4 bg-white w-full ${expanded ? 'hidden' : ''}`}>
        {children}
      </div>
    </div>
  );
};

export default ExpandablePanel
